import { Loader } from "@/shared/components/ui/icons"

interface IProps {
  show?: boolean
}

export function TableFetchingEffect({ show }: IProps) {
  if (!show) return null

  return (
    <div className="absolute z-40 flex size-full justify-center bg-[rgba(190,190,190,.1)] backdrop-blur-[2px] transition-all">
      <Loader
        className="mt-48 size-14 animate-spin *:fill-blue-500"
        style={{
          animationDuration: ".24s"
        }}
      />
    </div>
  )
}
